// The shop templates need these globals; marketing pages do not.
import axios from "axios";
import { createApp } from "vue/dist/vue.esm-bundler";

window.axios = axios;
window.createApp = createApp;

require("./webshop");
